import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Gallery } from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import { Contact } from '../components/Contact';
import TeamSection from '../components/TeamSection';
import HomeBookingSection from '../components/booking/HomeBookingSection';
import Deliciousmenu from '../components/Deliciousmenu';
import { LiveMusic } from '../components/LiveMusic';
import { Link } from 'react-router-dom';

interface HomeProps {
  language: string;
}

export function HomePage({ language }: HomeProps) {
  return (
    <>
      <Hero language={language} />

      <About language={language} />
      <Deliciousmenu language={language} />
      <Gallery language={language} />

      <LiveMusic language={language} />

      <Testimonials language={language} />
     
      <Contact language={language} />
    </>
  );
} 